import {
  filter,
  compose,
  set,
  lensPath,
  map,
  find,
  pathOr,
  equals,
  includes,
  flatten,
  uniqBy,
} from 'ramda';
import { BCPipelineConfig } from './breakoutfinance';
import { getDefaultPipelineConfig } from 'src/features/Advisors/Dashboards/PipeLine/mortgage';
import { authenticatedUser } from 'src/utilities/storage';
import { appPipelineConfig } from './app';
import { mbwiPipelineConfig } from './mbwi';
import { rsntPipelineConfig } from 'src/features/Advisors/Dashboards/PipeLine/rsnt';
import { firstcbtPipelineConfig } from './firstcbt';
import {
  ADVISOR_ADMINCENTER_MANAGEUSER_ADDISO_VISIT,
  ADVISOR_ADMINCENTER_USERS_MANAGE_PERMISSION,
} from 'src/features/RBAC/Rules/permissionData';
import { STATUS_DELETED, STATUS_MASKED } from 'src/services/constants';
import {
  USER_ONBOARD_ADMIN_ISO,
  USER_ONBOARD_APPLICANT,
} from 'src/services/constants/accounts';
import { concatString } from 'src/utilities/concatString';
import SiteSettings from 'src/siteSetting';
import { starPipelineConfig } from './star';
import { isNotEmpty } from 'src/utilities/hasValue';

export const getUsersTabByPermissions = (permissions: any) => {
  const permissionNames = map(pathOr('', ['name']), permissions);
  return filter(
    (item: any) =>
      includes(pathOr('', ['permissionName'], item), permissionNames),
    userTabsConfig,
  );
};

/**
 * get current logged in user's pipe line config based on namespaceId and logged in role
 * @param namespaceId
 * @returns
 */
export const getPipeLineByNamespaceAndRole = (namespaceId: any) => {
  const roles = authenticatedUser.rolesId.get()
    ? authenticatedUser.rolesId.get()
    : [];
  const getRolePipeLine = filter(
    (item: any) =>
      equals(pathOr('', ['namespaceId'], item), namespaceId) &&
      includes(pathOr('', ['role'], item), roles),
  );
  const configs = getRolePipeLine(PipeLineConfig);
  const results = isNotEmpty(configs)
    ? configs
    : getRolePipeLine(getDefaultPipelineConfig());
  return {
    namespaceId,
    roles,
    tabs: uniqBy(
      pathOr('', ['key']),
      flatten(map(pathOr([], ['tabs']), results)),
    ),
  };
};

/**
 * add title and default tab matching alltabs keys and current pipeline config keys.
 * @param applicationViewPrefsContext
 * @param allTabs
 * @returns
 */
export const updateTabConfig = (
  applicationViewPrefsContext: any,
  allTabs: any,
) => {
  const result = filter(
    (tab: any) =>
      applicationViewPrefsContext.some((item: any) =>
        equals(pathOr('', ['key'], item), pathOr('', ['key'], tab)),
      ),
    allTabs,
  );

  const updTabs = map(
    (tab: any) =>
      compose(
        set(
          lensPath(['title']),
          pathOr('', ['tabName'], matchTabs(applicationViewPrefsContext, tab)),
        ),
        set(
          lensPath(['defaultTab']),
          pathOr(
            '',
            ['tabNumber'],
            matchTabs(applicationViewPrefsContext, tab),
          ),
        ),
      )(tab),
    result,
  );
  return updTabs;
};

/**
 *
 * matching alltabs keys and current pipeline config keys
 * @param applicationViewPrefsContext
 * @param tab
 * @returns
 */
const matchTabs = (applicationViewPrefsContext: any, tab: any) => {
  return find(
    (item: any) => equals(pathOr('', ['key'], tab), pathOr('', ['key'], item)),
    applicationViewPrefsContext,
  );
};

export const USER_ACTIONS = [
  'Delete',
  'Suspend',
  'Restore',
  'Reset Password',
  'Edit',
];

// TODO: has to be self service on permission admin can able to select what role match and what not matching and Actions.
const userTabsConfig = [
  {
    permissionName: ADVISOR_ADMINCENTER_USERS_MANAGE_PERMISSION,
    title: SiteSettings.generalAppTitle(),
    role: {
      not_matching: map(
        (item) => [item],
        [USER_ONBOARD_APPLICANT, USER_ONBOARD_ADMIN_ISO],
      ),
      matching: {},
    },
    status: {
      not_matching: concatString(',', [STATUS_DELETED, STATUS_MASKED]),
      matching: '',
    },
    actions: USER_ACTIONS,
    optionalActions: ['Allocate Owner'],
  },
  {
    permissionName: ADVISOR_ADMINCENTER_MANAGEUSER_ADDISO_VISIT,
    title: 'Iso',
    role: {
      not_matching: [],
      matching: {
        is_all_of: [USER_ONBOARD_ADMIN_ISO],
      },
    },
    status: {
      not_matching: concatString(',', [STATUS_DELETED, STATUS_MASKED]),
      matching: '',
    },
    actions: ['Delete', 'Edit', 'Suspend'],
  },
  // TODO: Enable this once account delete resolved
  // {
  //     permissionName: ADVISOR_ADMINCENTER_USERS_MANAGE_PERMISSION,
  //     title: 'Applicants',
  //     role: {
  //         not_matching: '',
  //         matching: concatString(',', [USER_ONBOARD_APPLICANT]),
  //     },
  //     status: {
  //         not_matching: concatString(',', [STATUS_DELETED]),
  //         matching: '',
  //     },
  //     actions: ['Delete', 'Edit', 'Suspend']
  // }
];

const PipeLineConfig = flatten([
  mbwiPipelineConfig,
  rsntPipelineConfig,
  BCPipelineConfig,
  starPipelineConfig,
  firstcbtPipelineConfig,
  appPipelineConfig,
]);
